import React from "react";
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink, Image, BlobProvider, pdf } from "@react-pdf/renderer";
import moment from "moment";
import { numeral, setLocale } from "../../..";
import { ListItemText, makeStyles } from "@material-ui/core";
import selects from "../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    link: {
      textDecoration: "none"
    }
  };
});
var styles = StyleSheet.create({
  logo: {
    width: "30%"
  },
  billData: {
    width: "70%",
    alignItems: "flex-end",
    justifyContent: "center"
  },
  header: {
    marginBottom: "16px",
    display: "flex",
    flexDirection: "row",
    padding: "16px"
  },
  personsData: {
    display: "flex",
    flexDirection: "row",
    width: "60%",
    marginLeft: "20%",
    marginTop: "16px"
  },
  personData: {
    fontSize: 10,
    width: "50%",
    alignItems: "center",
    display: "flex",
    "flex-direction": "column"
  },
  dates: {
    width: "100%",
    textAlign: "right",
    fontSize: 10,
    paddingRight: "16px",
    marginBottom: "16px"
  },
  //table
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    borderRight: 1,
    borderBottom: 1,
    borderLeft: 1
  },
  tableRowHeader: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#a2a2a2"
  },
  tableRowBody: {
    margin: "auto",
    flexDirection: "row",
    borderRight: 1,
    borderBottom: 1,
    borderLeft: 1
  },
  tableCellHeader: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    paddingBottom: 4
  },
  tableCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10
  },
  tableSmallCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 8
  },
  tableBigCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 12
  },
  tableSmallCellLeft: {
    margin: "auto",
    marginLeft: 0,
    paddingLeft: 3,
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 8
  },
  tableCellLeft: {
    margin: "auto",
    marginLeft: 0,
    paddingLeft: 3,
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10
  },
  tableCellBold: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10,
    fontWeight: 900
  },
  colDay: {
    width: "20%"
  },
  colEmployee: {
    width: "30%"
  },
  colHourStart: {
    width: "15%"
  },
  colHourEnd: {
    width: "15%"
  },
  colDuration: {
    width: "20%"
  },
  container: {
    flexDirection: "row",
    "@media max-width: 400": {
      flexDirection: "column"
    }
  },
  leftColumn: {
    flexDirection: "column",
    width: 170,
    marginLeft: 30,
    marginRight: 15,
    marginTop: 20,
    "@media max-width: 400": {
      width: 290,
      marginRight: 30
    },
    "@media orientation: landscape": {
      width: 200,
      marginRight: 50
    }
  },
  rightColumn: {
    flexDirection: "column",
    flexGrow: 1,
    flexShrink: 1,
    marginLeft: 15,
    marginRight: 30,
    marginTop: 20,
    borderStyle: "dashed solid double",
    border: 1,
    borderWidth: 2,
    "@media max-width: 400": {
      marginTop: 10,
      marginLeft: 30
    }
  },
  table: {
    display: "table",
    width: "100%",
    flexDirection: "column",
    flexShrink: 1,
    padding: "16px"
  },
  tableColHeader: {
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    width: "17%"
  },
  tableCol: {
    flexGrow: 1,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  colType: {
    width: "30%",
    backgroundColor: "#a2a2a2"
  },
  colImport: {
    width: "30%"
  },
  paymentMethod: {
    backgroundColor: "#a2a2a2",
    borderRadius: 4,
    width: "60%",
    marginLeft: "20%",
    marginBottom: 32
  }
});

var PdfShiftReport = function PdfShiftReport(_ref) {
  var data = _ref.data,
      translation = _ref.translation;
  return /*#__PURE__*/React.createElement(Document, null, /*#__PURE__*/React.createElement(Page, {
    size: "A4"
  }, /*#__PURE__*/React.createElement(View, {
    fixed: true,
    style: styles.header
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.logo
  }, /*#__PURE__*/React.createElement(Image, {
    source: "https://sm-logos-23132.s3.eu-west-3.amazonaws.com/black-logo.png"
  })), /*#__PURE__*/React.createElement(View, {
    style: styles.billData
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.titleBill
  }, translation ? translation.title : "Shift report"))), /*#__PURE__*/React.createElement(View, {
    style: styles.dates,
    fixed: true
  }, /*#__PURE__*/React.createElement(Text, null, translation ? translation.date_start : "Date Start: ", " ", data.dateStart), /*#__PURE__*/React.createElement(Text, null, translation ? translation.date_end : "Date End: ", " ", data.dateEnd)), /*#__PURE__*/React.createElement(View, {
    style: styles.table,
    wrap: true
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowHeader
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.colDay
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.columns.day : "Day")), /*#__PURE__*/React.createElement(View, {
    style: styles.colEmployee
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.columns.employee : "Employee")), /*#__PURE__*/React.createElement(View, {
    style: styles.colHourStart
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.columns.hour_start : "Hour start")), /*#__PURE__*/React.createElement(View, {
    style: styles.colHourEnd
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.columns.hour_end : "Hour end")), /*#__PURE__*/React.createElement(View, {
    style: styles.colDuration
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.columns.duration : "Duration"))), data ? data.reports.map(function (report) {
    return /*#__PURE__*/React.createElement(View, {
      style: styles.tableRow
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.colDay
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCellLeft
    }, report.day)), /*#__PURE__*/React.createElement(View, {
      style: styles.colEmployee
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, report.employee, " ")), /*#__PURE__*/React.createElement(View, {
      style: styles.colHourStart
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, report.hourStart)), /*#__PURE__*/React.createElement(View, {
      style: styles.colHourEnd
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, report.hourEnd, " ")), /*#__PURE__*/React.createElement(View, {
      style: styles.colDuration
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, report.duration, " ")));
  }) : null), /*#__PURE__*/React.createElement(View, {
    style: {
      justifySelf: "flex-end",
      alignItems: "center"
    },
    fixed: true
  }, /*#__PURE__*/React.createElement(Text, {
    fixed: true,
    render: function render(_ref2) {
      var pageNumber = _ref2.pageNumber,
          totalPages = _ref2.totalPages;
      return totalPages > 1 ? "".concat(pageNumber, " / ").concat(totalPages) : null;
    }
  }))));
};

export { PdfShiftReport };